import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import ResidencyBookingForm from "./ResidencyBookingForm";
import ResidencyHighlights from "./ResidencyHighlights";
import ResidencyBasics from "./ResidencyBasics";
import ResidenciesHeader from "./ResidenciesHeader";
import ResidenciesDetailsTab from "./ResidenciesDetailsTab";
import axios from "axios";
import { SessionContext } from '../../common/SessionContext';

function ResidenciesWrap() {

    const { session } = useContext(SessionContext);
    const currentCurrency = session.currency;

    // API configuration constants
    const API_URL = "https://test.campfr.com/api/get_residencies/";
    const API_TOKEN = process.env.REACT_APP_API_TOKEN;

    // State management for data, loading status, and error handling
    const [residencies, setResidencies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        /**
         * Fetches data from the API with authentication token
         */

        const fetchData = async () => {
            try {
                const response = await axios.get(API_URL, {
                    headers: { "X-API-TOKEN": API_TOKEN }
                });

                console.log("API Response:", response.data);

                // Update component state with fetched data
                //const residenciesArr = Array.isArray(response.data) ? response.data : Object.values(response.data);
                const residenciesArr = response.data;
                setResidencies(residenciesArr);
                setLoading(false);
            } catch (error) {
                console.error("API Error:", error);
                setError(error.message || "Failed to fetch API");
                setLoading(false);
            }
        };

        fetchData();
    }, []); // Empty dependency array means this effect runs once on mount

    console.log(error);

    return (
        <>
            <div className="package-details-wrapper pt-110">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="tour-package-details">
                                <ResidenciesHeader />
                                <ResidenciesDetailsTab residencies={residencies} />
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="package-sidebar">
                                <ResidencyHighlights />
                                <ResidencyBasics />
                                <ResidencyBookingForm residencies={residencies} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ResidenciesWrap;
